import httpApi from "@/api/http"

const getQuestionnaireData = () => {
  return httpApi.get('/get-data', )
    .then((response) => {
      try {
  
          return response.data
      
        
      } catch (error) {
        return null
      }
    })
}
const saveQuestionnaireData = (userData, dataMarketing = {phone: false, mail: false,}) => {
  return httpApi.post('/save-data', {user_data: userData , marketing: dataMarketing} )
    .then((response) => {
      try {
  
          return response.data
      
        
      } catch (error) {
        return null
      }
    })
}

const saveConsents = (dataMarketing = {phone: false, mail: false,}) => {
  return httpApi.post('/save-consents', {...dataMarketing} )
    .then((response) => {
      try {
  
          return response.data
      
        
      } catch (error) {
        return null
      }
    })
}
export {
  getQuestionnaireData,
  saveQuestionnaireData,
  saveConsents
}